module.exports = __webpack_public_path__ + "img/Khervie_dev.77f4b941.jpg";